import { call, takeEvery, all, put } from "redux-saga/effects";
import { CREATE_APP_ROLE, GET_APP_ROLES, GET_CHECK_ROLE, GET_ROLE, REMOVE_APP_ROLE, UPDATE_APP_ROLE } from "./types";
import api from "../../client/utils/clientApiHelper";
import { setAppRoles, setCheckRole, setCreateAppRole, setIsCheck, setIsCheckRole, setRemoveAppRole, setRole, setUpdatedAppRole } from './action';
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { API_URL, apiMethod, apiType } from "utils";
import { IPayload } from "Model/IPayload";

function* getAppRoles(req: any): any {
  yield put(globalLoaderText("fetching Role Grid Data...."));
  try {
    const selectedId = req.payload;
    let payloadData : IPayload = {
      apiMethod: apiMethod.POST,
      apiType: apiType.Identity,
      endpoint: `roles/applications`,
      payload: selectedId
    }
    const response = yield call(
      api.callRolesPost,
      API_URL.PostWebApp,payloadData 
    );
    yield put(setAppRoles(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(setAppRoles({ count: 0, data: [] }));
    yield put(globalLoaderText(""));
  }
}

function* deleteAppRole(req: any): any {
  try {
    yield put(globalLoaderText("Removing Role...."));
    const roleId = req.payload;
    let payloadData : IPayload= {
      apiMethod: apiMethod.PUT,
      apiType: apiType.Identity,
      endpoint: `roles/${roleId}`,
      payload : null
    }
    const response = yield call(
      api.callRolesPost,API_URL.PostWebApp,payloadData
      
    );
    if (response) {
      yield put(globalLoaderText(""));
      yield put(setRemoveAppRole(true));
    }
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(setRemoveAppRole(false));
  }
}


function* editAppRole(req: any): any {
  try {
    const requestBody = req.payload;
    let payloadData : IPayload= {
      apiMethod: apiMethod.PUT,
      apiType: apiType.Identity,
      endpoint: `roles`,
      payload: requestBody
    }
    yield put(globalLoaderText("Updating Role...."));
    const response = yield call(
      api.callRolesPost,
      API_URL.PostWebApp, payloadData
    );
    if (response) {
      yield put(setCreateAppRole(response))
      yield put(globalLoaderText(""));
    }
  } catch (error) {
    yield put(setCreateAppRole("error"))
    yield put(globalLoaderText(""));
  }
}

function* createAppRole(req: any): any {
  try {
    yield put(globalLoaderText("Creating Role...."));
    const requestBody = req.payload;
    let payloadData : IPayload= {
      apiMethod: apiMethod.POST,
      apiType: apiType.Identity,
      endpoint: `roles/`,
      payload: requestBody
    }
    const response = yield call(
      api.callRolesPost,
      API_URL.PostWebApp, payloadData
    );
    if (response) {
      yield put(setCreateAppRole(response))
      yield put(globalLoaderText(""));
    }
  } catch (error) {
    yield put(setCreateAppRole("error"))
    yield put(globalLoaderText(""));
  }
}

function* getRoleById(req: any): any {
  try {
    yield put(globalLoaderText("Fetching Data...."));
    const roleId = req.payload;
    let payloadData : IPayload= {
      apiMethod: apiMethod.GET,
      apiType: apiType.Identity,
      endpoint: `roles/${roleId}`,
      payload : null
    }
    const response = yield call(api.callUserPost, API_URL.PostWebApp,payloadData);
    if (response) {
      yield put(globalLoaderText(""));
      yield put(setRole(response));
    }
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(setRole({}));
  }
}

function* checkRoleDuplication(req: any): any {
  yield put(globalLoaderText("Checking Duplication...."));
  try {
    let roleName = req.payload.roleName;
    let roleId = req.payload.roleId;
    let payloadData : IPayload= {
      apiMethod: apiMethod.GET,
      apiType: apiType.Identity,
      endpoint: `roles/check?roleName=${roleName}&roleId=${roleId}`,
      payload : null
    }
    const response = yield call(
      api.callUserPost,API_URL.PostWebApp,payloadData
      
    );
    yield put(setCheckRole(response));
    yield put(setIsCheck((prev: any) => !prev));
    if (response == false) {

      yield put(setIsCheckRole(false));
    } else {
      yield put(setIsCheckRole(true));
      yield put(setCreateAppRole(0))
    }
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(setIsCheckRole(true));
    yield put(setCheckRole(true));
    yield put(setCreateAppRole(0))
    yield put(globalLoaderText(""));
  }
}

function* watchAppOnboardingSaga() {
  yield takeEvery(GET_APP_ROLES, getAppRoles);
  yield takeEvery(REMOVE_APP_ROLE, deleteAppRole)
  yield takeEvery(GET_ROLE, getRoleById)
  yield takeEvery(CREATE_APP_ROLE, createAppRole)
  yield takeEvery(UPDATE_APP_ROLE, editAppRole)
  yield takeEvery(GET_CHECK_ROLE, checkRoleDuplication)
}

export default function* combinedSaga() {
  yield all([watchAppOnboardingSaga()]);
}
